import tw, { styled, css } from "twin.macro";
import { useLanguage } from "hooks/useLanguage";
import Layout from "components/Layout";

export default function PrivacyPolicy() {
  const { termsAndCondition, privacyAndPolicy } = useLanguage()

  return (
    <Layout>
      <section tw="pt-10 pb-12">
        <div tw="container mx-auto lg:px-20">
          <div tw="border border-gray-200 p-5 md:p-8 rounded-lg bg-white">
            <Content>
              <h2 tw="text-center text-gray-600">{privacyAndPolicy?.title}</h2>
              <hr tw="mb-6 md:mb-10" />
              <div>
                <h4>{privacyAndPolicy?.introduction?.title}</h4>
                <ul>
                  {privacyAndPolicy?.introduction?.paraList.map((res, key) => {
                    return <li key={key}>{res}</li>
                  })}
                </ul>
                <h4>{privacyAndPolicy?.existingLaw?.title}</h4>
                <p>{privacyAndPolicy?.existingLaw?.intro}</p>

                {/*  Data Protection */}
                <h4>{privacyAndPolicy?.dataProtection?.title}</h4>
                <p>{privacyAndPolicy?.dataProtection?.paraOne?.intro}</p>
                <ul>
                  {privacyAndPolicy?.dataProtection?.paraOne?.list.map((res, key) => {
                    return (
                      <li key={key}>
                        {res.title}
                        <ol>
                          {res?.subList.map((res, key) => {
                            return <li key={key}>{res}</li>
                          })}
                        </ol>
                      </li>
                    )
                  })}
                </ul>
                <p>
                  {privacyAndPolicy?.dataProtection?.paraOne?.details}
                </p>
                <ul>
                  {privacyAndPolicy?.dataProtection?.paraList.map((res, key) => {
                    return <li key={key}>{res}</li>
                  })}
                </ul>

                {/* Use Of Data */}
                <h4>{privacyAndPolicy?.useOfData?.title}</h4>
                <ol>
                  {privacyAndPolicy?.useOfData?.paraList.map((res, key) => {
                    return (
                      <li key={key}>
                        {res.title}
                        <ul>
                          {res?.list.map((res, key) => {
                            return <li key={key}>{res}</li>
                          })}
                        </ul>
                      </li>
                    )
                  })}
                </ol>

                {/* Data Storage */}
                <h4>{privacyAndPolicy?.dataStorage?.title}</h4>
                <p>
                  {privacyAndPolicy?.dataStorage?.intro}
                </p>

                {/* Data Deletion */}
                <h4>{privacyAndPolicy?.dataDeletion?.title}</h4>
                <ol>
                  {privacyAndPolicy?.dataDeletion?.paraList.map((res, key) => {
                    return (
                      <li key={key}>
                        {res.title}
                        <ul>
                          {res?.list.map((res, key) => {
                            return <li key={key}>{res}</li>
                          })}
                        </ul>
                      </li>
                    )
                  })}
                </ol>

                {/* Limitation */}
                <h4>{privacyAndPolicy?.limitation?.title}</h4>
                <ol>
                  {privacyAndPolicy?.limitation?.paraList.map((res, key) => {
                    return <li key={key}>{res}</li>
                  })}
                </ol>

                {/* Cookies */}
                <h4>{privacyAndPolicy?.cookies?.title}</h4>
                <ul>
                  {privacyAndPolicy?.cookies?.paraList.map((res, key) => {
                    return (
                      <li key={key}>
                        {res}
                      </li>
                    )
                  })}
                </ul>

                {/*  intellectual Property */}
                <h4>{privacyAndPolicy?.intellectualProperty?.title}</h4>
                <ul>
                  <li>{privacyAndPolicy?.intellectualProperty?.paraOne}</li>
                  <li>{privacyAndPolicy?.intellectualProperty?.paraTwo?.title}</li>
                  <ol>
                    {privacyAndPolicy?.intellectualProperty?.paraTwo?.list.map((res, key) => {
                      return <li key={key}>{res}</li>
                    })}
                  </ol>
                </ul>

                {/*  Privacy  and Policy Change */}
                <h4>{privacyAndPolicy?.privacyAndPolicyChange?.title}</h4>
                <p>{privacyAndPolicy?.privacyAndPolicyChange?.intro}</p>

                {/* Contact us */}
                <h4>{termsAndCondition?.contactUs?.title}</h4>
                <p>
                  {termsAndCondition?.contactUs?.intro}
                </p>
                <p>{termsAndCondition?.contactUs?.email}</p>
                <p>{termsAndCondition?.contactUs?.whatsApp}</p>
                <p>{termsAndCondition?.contactUs?.lastUpdate}</p>
              </div>
            </Content>
          </div>
        </div>
      </section>
    </Layout>
  );
}

const Content = styled.div(() => [
  css`
    h2 {
      ${tw`text-2xl md:text-3xl font-bold mb-4`}
    }

    h3 {
      ${tw`text-lg md:text-xl font-bold mb-4`}
    }

    h4 {
      ${tw`text-base md:text-lg font-semibold mb-2`}
    }

    p {
      ${tw`mb-1 md:mb-2 text-sm leading-6`}
    }

    ul {
      ${tw`list-disc pl-6 md:pl-8 mb-6`}

      li {
        ${tw`mb-1 md:mb-2 text-sm leading-6`}
      }
    }

    ol {
      ${tw`list-decimal pl-6 md:pl-8 mb-6`}

      li {
        ${tw`mb-1 md:mb-2 text-sm leading-6`}
      }
    }

    strong {
      ${tw`font-semibold`}
    }
  `,
]);
